import {http} from '../utils'

const getDropdown = value => {
  const url = `/api/v1/combobox/getComboBoxList/${value}`
  return http.post(url, {})
}

const getRuleData = params => {
  const url = `/api/v1/rule/getRulePage`
  return http.post(url, params)
}

const addRule = params => {
  const url = `/api/v1/rule/addRule`
  return http.post(url, params)
}

const getRuleDetail = params => {
  const url = `/api/v1/rule/getRuleDetail`
  return http.post(url, params)
}

const editRule = params => {
  const url = `/api/v1/rule/editRule`
  return http.post(url, params)
}

const deleteRule = params => {
  const url = `/api/v1/rule/deleteRule`
  return http.post(url, params)
}

const getTableNameLinkage = () => {
  const url = `/api/v1/table/getBaseTableList`
  return http.get(url, {})
}

const addSQL = params => {
  const url = `/api/v1/rule/addSql`
  return http.post(url, params)
}

const editSQL = params => {
  const url = `/api/v1/rule/editSql`
  return http.post(url, params)
}

const getSQLDetail = params => {
  const url = `/api/v1/rule/getSqlDetail`
  return http.post(url, params)
}

const onActiveChange = params => {
  const url = `/api/v1/rule/ruleActivate`
  return http.post(url, params)
}

const getRuleStatusLog = params => {
  const url = `/api/v1/rule/getRuleStatusLog`
  return http.get(url, params)
}

const getVersionList = params => {
  const url = `/api/v1/ruleVersion/getRuleVersionList`
  return http.post(url, params)
}

const onRecord = params => {
  const url = `/api/v1/ruleVersion/record`
  return http.post(url, params)
}

const getSQLVersionDetail = params => {
  const url = `/api/v1/ruleVersion/getSqlVersionDetail`
  return http.post(url, params)
}

const getRuleVersionDetail = params => {
  const url = `/api/v1/ruleVersion/getRuleVersionDetail`
  return http.post(url, params)
}

const onRecover = params => {
  const url = `/api/v1/ruleVersion/recover`
  return http.post(url, params)
}

const importRulesPre = params => {
  const url = `/api/v1/rule/importRulesPre`
  return http.post(url, params)
}

export default {
  getDropdown,
  getRuleData,
  addRule,
  editRule,
  getRuleDetail,
  deleteRule,
  getTableNameLinkage,
  addSQL,
  editSQL,
  getSQLDetail,
  onActiveChange,
  getRuleStatusLog,
  getVersionList,
  onRecord,
  getSQLVersionDetail,
  getRuleVersionDetail,
  onRecover,
  importRulesPre
}
